import { getPageType } from '../helper';
import { platformNames } from 'shared/constants';
import { SEARCH_PRODUCTS } from 'constants/strings';
import { SEARCH_INPUT_PLACEHOLDER } from 'constants/placeHolders';

const LP_VALUE = 'searchResults';
const SEARCH_URL = '/search/result/';

export const getSearchURL = (pathname: string) => {
  const lpValue = pathname === SEARCH_URL ? `&lp=${LP_VALUE}` : '';
  const pageType = getPageType(pathname) || 'other';
  const searchLink = `/search/query?sourcePage=${pageType}${lpValue}`;
  return searchLink;
};

export const getPlaceholderText = () => {
  const isMan = __PLATFORM__ === platformNames.MEN;
  return isMan ? SEARCH_PRODUCTS : SEARCH_INPUT_PLACEHOLDER;
};
